export default {
  GoogleDrive: {
    ErrorConnectGoogleDrive: 'Liên kết không thành công, vui lòng thử lại',
    SyncToGoogleDrive: 'Lưu tài liệu lên Google Drive',
    TurnOffSyncToGoogleDrive: 'Tắt lưu tự động lên Drive',
    AddToGoogleDrive: 'Thêm tài liệu - Cho phép them từ GG drive or từ máy tính',
    SetupSuccess: 'Liên kết tài khoản thành công',
    SetupFail: 'Liên kết tài khoản thất bại',
    AccessToGoogleDrive: 'Truy cập Drive',
    DestroyLink: 'Hủy liên kết'
  }
}
